import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@resurs/midas-react'
import { getCountryName, getText } from '../../../internal/TextLabels/text'
import { getRoleName } from '../../../models/roles'

const StrongText = ({ children }) => (
  <strong>
    <mark>{children}</mark>
  </strong>
)

StrongText.propTypes = {
  children: PropTypes.string.isRequired,
}

const NewsTargetInfo = ({ targetData }) => {
  const strongList = (list, func) =>
    list.map(item => (
      <Chip round disabled>
        {func(item)}
      </Chip>
    ))

  const { target, roleTarget } = targetData
  return (
    <div>
      {(target === 'all' || roleTarget === 'all') && (
        <Chip round disabled>
          {getText('news.add.recipientSection.all')}
        </Chip>
      )}
      {target === 'countries' &&
        strongList(targetData.newsCountries, country =>
          getCountryName(country.id),
        )}
      {target === 'representatives' &&
        strongList(targetData.newsRepresentatives, rep => rep.name || rep.id)}
      {target === 'stores' &&
        strongList(targetData.newsStores, store => store.name || store.id)}
      {roleTarget !== 'all' &&
        strongList(targetData.newsRoles, role => getRoleName(role.id))}
    </div>
  )
}

NewsTargetInfo.propTypes = {
  targetData: PropTypes.object.isRequired,
}

export default NewsTargetInfo
